import { useEffect, useState, useRef, useMemo } from 'react';
import { Card, Row, Col, Form, DatePicker, Button,Select } from 'antd';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import { useHistory, useLocation } from "react-router-dom";
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import moment from 'moment';
import {getToday, isDateBeforeToday} from 'shared/utils/dateUtils';
import Vehicles from './Vehicles';

export default function SearchVehicle() {
    const dateFormat = 'D/M/YYYY';
    const exportFormat = 'DD-MM-YYYY'
    const { search } = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(search), [search])
    const [endPoint, setEndPoint] = useState()
    const history = useHistory();
    const [form] = Form.useForm();
    const myRef = useRef();
    const defaultExportFilename='Anytime_BTMDailyStatsReport_'
    const [exportFilename, setExportFilename] = useState(defaultExportFilename)
    const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth' });
    const exportDataTitleMap = {
        '1': 'Anytime',
        '2': 'IM'
    };
    const exportDataTitle = exportDataTitleMap[queryParams.get('channel')] || 'ALL';
    
    const formItemLayout = {
        labelCol: {
            span: 10
        },
        wrapperCol: {
            span: 12
        },
    };

    useEffect(() => {
        const channelPrefix = queryParams.get('channel') === '1' ? 'AN_' : 'IM_'
        form.setFieldsValue({
            'DateFrom': queryParams.get('DateFrom') ? moment(queryParams.get('DateFrom'), dateFormat) : null,
            'DateTo': queryParams.get('DateTo') ? moment(queryParams.get('DateTo'), dateFormat) : null,
            'channel':queryParams.get('channel') ? queryParams.get('channel'):'ALL'
        })

        setExportFilename(`${queryParams.get('channel') ? `${channelPrefix}${defaultExportFilename}` :defaultExportFilename }${form.getFieldValue('DateFrom') ? form.getFieldValue('DateFrom')?.format(exportFormat) : getToday().today}_${form.getFieldValue('DateFrom') ? form.getFieldValue('DateTo')?.format(exportFormat) : getToday().today}`)
        setEndPoint(`${EndPoints.REPORTS.GETTRIPSBYDATE}?${queryParams.toString()}`);
    }, [queryParams, form])

    const onFinish = (fieldsValues) => {
        const values = {
            ...fieldsValues,
            'DateFrom': fieldsValues.DateFrom?.format(dateFormat),
            'DateTo': fieldsValues.DateTo?.format(dateFormat),
            'channel': fieldsValues.channel !== 'ALL' ? fieldsValues.channel: null
        }
        Object.keys(values).forEach(key => values[key] === null || values[key] === undefined || values[key] === '' ? delete values[key] : values[key]);
        const params = new URLSearchParams(values);
        history.replace({ search: `?${params}` });
        setEndPoint(`${EndPoints.REPORTS.GETTRIPSBYDATE}?${params}`);
        executeScroll();
    };

    return (
        <>
            <Card type="inner" headStyle={headerStyle} title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση" >
                <Row style={rowStyle}>
                    <Col style={{ color: 'black' }} span={24}>Κριτήρια Αναζήτησης</Col>
                </Row>
                <Form

                    {...formItemLayout}
                    form={form}
                    onFinish={onFinish}
                >
                    <Row>
                        <Col span={12} >
                            <Form.Item                               
                                name="DateFrom"
                                label="Ημερομηνία Συμβάντος Από:"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Το πεδίο είναι απαραίτητο'
                                    }
                                ]}
                            >
                                <DatePicker disabledDate={isDateBeforeToday} data-testid="DateFrom" style={{ width: '70%' }} format={dateFormat} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item                                
                                name="DateTo"
                                label="Ημερομηνία Συμβάντος Έως:"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Το πεδίο είναι απαραίτητο'
                                    }
                                ]}
                            >
                                <DatePicker disabledDate={isDateBeforeToday} data-testid="DateTo" style={{ width: '70%' }} format={dateFormat} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="channel" label="Channel:" >
                                <Select style={{width:'70%'}} defaultValue="ALL" options={[{value:'1', label:'Anytime'},{value:'2', label:'IM'},{value:'ALL', label:'ALL'}]} />
                            </Form.Item>
                        </Col>
                        <Col span={8} offset={10} >
                            <Form.Item>
                                <Button htmlType="submit" style={{ backgroundColor: '#e6e6e6' }} >
                                    Αναζήτηση
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
            {endPoint?.includes('?DateFrom=') && endPoint?.includes('DateTo=') ?
                <Col ref={myRef}>
                    <Vehicles endPoint={endPoint} exportFilename={exportFilename} exportDataTitle={exportDataTitle} />
                </Col> : null
            }

        </>
    );
}